export default __webpack_public_path__ + "static/media/PPI-patio-011.fb312775.jpg";